"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconMore = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "More" }, props),
        react_1.default.createElement("title", null, "More"),
        react_1.default.createElement("path", { d: "M76.471 68.65L90.978 86.86l10.585-8.432-14.507-18.211-10.585 8.432z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M65.78 55.146a26.144 26.144 0 003.14-2.679c10.039-10.04 10.039-26.325 0-36.364-9.654-9.654-25.083-10.029-35.175-1.115L65.78 55.146zm-21.3-26.722c.3-.321.622-.621.975-.89 3.729-2.913 9.118-2.25 12.032 1.48 2.915 3.728 2.25 9.117-1.478 12.032-.3.235-.621.45-.943.642", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M77.791 111.428l20.11-16.018L33.81 14.935c-11.11 8.85-12.943 25.028-4.093 36.14l27.471 34.488 20.604 25.865z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M57.198 85.574c-.128.15-.278.31-.418.45-3.343 3.343-8.775 3.343-12.117 0-3.343-3.343-3.343-8.775 0-12.118.6-.6 1.328-1.125 2.046-1.51L32.33 54.341l-3.835 3.407c-12.279 12.279-12.279 32.175 0 44.454 11.807 11.807 30.664 12.257 43.017 1.35", fill: "#007562" })));
};
exports.default = BrandIconMore;
